import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { STORE_AVAILABILITY as dict } from '@/resources/dict'
import ALL_POC_STATUSES from '@/resources/enums/pocStatus'

import Modal from '@/components/generics/Modal'
import Button from '@/components/generics/Button'
import LoadingButton from '@/components/generics/LoadingButton'

import { useOpenOrClosePoc } from '@/proxy/seller/hooks'

import * as S from './styles'
import { segmentClient } from '@/analytics/segmentClient'
import { pathNameToSegmentScreenName } from '@/resources/utils/analytics'
import { OwnerSquad } from '@/analytics/generated/segment'
import { useLocation } from 'react-router-dom'

const StoreOpeningModal = ({
  show,
  handleCloseModal,
  handleSuccessfulOpening,
}) => {
  const { pathname } = useLocation()
  const [serverErrors, setErrors] = useState([])
  const [isProcessing, setIsProcessing] = useState(false)

  const openPoc = useOpenOrClosePoc()

  const openPartnerStore = async () => {
    try {
      setIsProcessing(true)

      const { openOrClosePoc: { success = false, errors = [] } = {} } =
        await openPoc.mutateAsync({
          input: {
            operation: ALL_POC_STATUSES.AVAILABLE,
          },
        })

      if (success) {
        setIsProcessing(false)
        handleSuccessfulOpening()
      } else {
        setIsProcessing(false)

        setErrors(errors?.map(error => error?.message) ?? [])
      }
    } catch {
      setIsProcessing(false)
    }
  }

  const renderErrorParagraph = error => (
    <S.ErrorParagraph key={error}>{error}</S.ErrorParagraph>
  )

  const hasErrors = serverErrors.length > 0

  useEffect(() => {
    if (show) {
      segmentClient.openStoreModalViewed({
        screen_name: pathNameToSegmentScreenName(pathname),
        modal_name: 'open-store-modal',
        owner_squad: OwnerSquad.DtcZeOrders,
      })
    }
  }, [pathname, show])

  return (
    <Modal id="open-store-modal" show={show}>
      <S.Content>
        <S.ModalTitle>{dict.openStoreModalTitle}</S.ModalTitle>
        <S.ModalContent>
          {hasErrors && (
            <S.ErrorParagraph id="server-errors">
              {serverErrors.map(renderErrorParagraph)}
            </S.ErrorParagraph>
          )}

          <S.ModalActions>
            <Button outline onClick={handleCloseModal} id="close-modal-button">
              {dict.cancel}
            </Button>
            <LoadingButton
              isLoading={isProcessing}
              onClick={openPartnerStore}
              id="open-partner-store-button"
            >
              {dict.openStore}
            </LoadingButton>
          </S.ModalActions>
        </S.ModalContent>
      </S.Content>
    </Modal>
  )
}

StoreOpeningModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleSuccessfulOpening: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
}

export default StoreOpeningModal
